import {Path, Rect, Svg} from 'react-native-svg';

const SettingsThemeIcon = () => (
  <Svg width="30" height="30" viewBox="0 0 30 30" fill="none">
    <Rect width="30" height="30" rx="7" fill="#FF9500" />
    <Path
      d="M15 8.5C11.4102 8.5 8.5 11.4102 8.5 15C8.5 18.5898 11.4102 21.5 15 21.5C18.5898 21.5 21.5 18.5898 21.5 15C21.5 11.4102 18.5898 8.5 15 8.5ZM15 20C12.2383 20 10 17.7617 10 15C10 12.2383 12.2383 10 15 10V20Z"
      fill="white"
    />
    <Path
      d="M15 6.5V4.5M15 25.5V23.5M23.5 15H25.5M4.5 15H6.5M21.364 8.636L22.778 7.222M7.222 22.778L8.636 21.364M21.364 21.364L22.778 22.778M7.222 7.222L8.636 8.636"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </Svg>
);

export default SettingsThemeIcon;
